module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_short_front_vector.34677b44.svg";